<template>

  <v-data-table
    :headers="headers"
    :items="_items"
    :server-items-length="_total"
    :footer-props="footer"
    :no-data-text="labels.nodata"
    :options.sync="options"
    :loading="loading"
    @click:row="$emit('click', $event)"
  >
    <template v-slot:item.price="{ item }">
      {{ item.price }} {{ currency }}
    </template>

    <template v-slot:item.category="{ item }">
      {{ $t(`products.category.${item.category}`) }}
    </template>

    <template v-slot:item.actions="{ item }">
      <responsive-icon :label="$t('issues.edit')" breakpoints="xs">
        <font-awesome-icon icon="pen" size="lg"></font-awesome-icon>
      </responsive-icon>
    </template>

  </v-data-table>

</template>

<script>
  import dataTable from '../../helpers/data-table.es6'
  import ResponsiveIcon from '../../shared/components/responsive-icon'

  export default {
    name: 'products-table',
    mixins: [ dataTable ],

    data () {
      return {
        headers: [
          { text: this.$tc('products.entity-name', 1), value: 'name' },
          { text: this.$t('category'), value: 'category' },
          { text: this.$t('price'), value: 'price' },
          { text: this.$t('shared.actions'), value: 'actions', sortable: false },
        ]
      }
    },

    computed: {
      currency () {
        return this.$store.state.site.currency
      }
    },

    components: {
      ResponsiveIcon
    }
  }
</script>

<style scoped lang="scss">

</style>
